<div [formGroup]="form">
  <div class="input-wrapper">
    <label for="firstName">{{ 'PERSONAL_INFO_FORM.NAME' | translate }}</label>
    <app-icam-input
      label="{{ 'PERSONAL_INFO_FORM.NAME' | translate }}"
      inputId="firstName"
      formControlName="firstName"
      [isSlim]="true"
      [ngClass]="isLight ? 'light' : 'dark'"
      />
  </div>
  <div class="input-wrapper">
    <label for="lastName">{{ 'PERSONAL_INFO_FORM.LAST_NAME' | translate }}</label>
    <app-icam-input
      label="{{ 'PERSONAL_INFO_FORM.LAST_NAME' | translate }}"
      inputId="lastName"
      formControlName="lastName"
      [isSlim]="true"
      [ngClass]="isLight ? 'light' : 'dark'"
      />
  </div>
  <div class="input-wrapper">
    <label for="email">Email</label>
    <app-icam-input
      label="Email"
      inputId="email"
      formControlName="email"
      [isSlim]="true"
      inputType="email"
      [ngClass]="isLight ? 'light' : 'dark'"
      />
  </div>
  <div class="input-wrapper">
    <label for="mobilePhone">{{ 'PERSONAL_INFO_FORM.PHONE' | translate }}</label>
    <app-icam-input
      label="{{ 'PERSONAL_INFO_FORM.PHONE' | translate }}"
      inputId="mobilePhone"
      formControlName="mobilePhone"
      [isSlim]="true"
      inputType="tel"
      [ngClass]="isLight ? 'light' : 'dark'"
      />
  </div>
  @if (!isAdminRole) {
    <div class="input-wrapper mb-2">
      <label for="companyGroupId">{{ 'USER_FORM.COMPANY_GROUP' | translate }}</label>
      <select
        id="companyGroupId"
        formControlName="companyGroupId"
        class="form-select filter-select rounded-0 mt-1"
        [ngClass]="isLight ? 'light' : 'dark'"
        [attr.disabled]="!isCurrentUserAdmin ? true : null"
      >
        <option value="">{{ 'USER_FORM.NO_COMPANY_GROUP' | translate }}</option>
        @for (group of companyGroups; track group.id) {
          <option [value]="group.id">{{ group.name }}</option>
        }
      </select>
    </div>
    @if (isEdit && form.get('companyGroupId')?.value) {
      <div class="machine-item form-check mb-2">
        <input
          type="checkbox"
          id="canImpersonate"
          formControlName="canImpersonate"
          class="form-check-input"
          [ngClass]="isLight ? 'light' : 'dark'"
          [attr.disabled]="!isCurrentUserAdmin ? true : null"
          style="opacity: 1; cursor: pointer;"
        />
        <label for="canImpersonate" class="form-check-label" style="cursor: pointer;">
          {{ 'USER_FORM.CAN_IMPERSONATE' | translate }}
        </label>
      </div>
      <small class="d-block mb-3" [ngClass]="isLight ? 'text-muted' : 'text-white'">
        {{ 'USER_FORM.CAN_IMPERSONATE_HINT' | translate }}
      </small>
    }
  }
  @if (isEdit) {
    <div class="input-wrapper">
      <label for="createdDate">{{ 'USER_FORM.CREATED_DATE' | translate }}</label>
      <app-icam-input
        label="{{ 'USER_FORM.CREATED_DATE' | translate }}"
        inputId="createdDate"
        formControlName="createdDate"
        [isSlim]="true"
        [ngClass]="isLight ? 'light' : 'dark'"
        />
    </div>
  }
  @if (isEdit) {
    <div class="input-wrapper">
      <label for="modifiedDate">{{ 'USER_FORM.MODIFIED_DATE' | translate }}</label>
      <app-icam-input
        label="{{ 'USER_FORM.MODIFIED_DATE' | translate }}"
        inputId="modifiedDate"
        formControlName="modifiedDate"
        [isSlim]="true"
        [ngClass]="isLight ? 'light' : 'dark'"
        />
    </div>
  }
</div>
